<template>
  <v-dialog v-model="dialog" persistent max-width="400px">
    <v-card class="rounded-lg">
      <v-card-title class="text-h6 font-weight-bold grey--text text--darken-2 pa-4 border-bottom">
        Aplicar Desconto
        <v-spacer></v-spacer>
        <v-btn icon @click="close">
          <v-icon>{{ icons.mdiClose }}</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-6">
        <v-text-field
          v-model="discountValue"
          label="Valor do Desconto (R$)"
          type="number"
          step="0.01"
          outlined
          dense
          autofocus
          prefix="R$"
          :rules="[rules.valid, rules.max]"
          @keydown.enter="confirm"
        ></v-text-field>
        
        <div class="caption grey--text">
          Subtotal atual: {{ subtotal | moneyBr }}
        </div>
      </v-card-text>

      <v-card-actions class="pa-4 pt-0">
        <v-spacer></v-spacer>
        <v-btn text @click="close">Cancelar</v-btn>
        <v-btn color="primary" @click="confirm" :disabled="!isValid">
          Aplicar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mdiClose } from '@mdi/js';

export default {
  name: "POSDiscountModal",
  data() {
    return {
      dialog: false,
      discountValue: null,
      subtotal: 0,
      icons: { mdiClose },
      rules: {
         valid: v => (!v || parseFloat(v) >= 0) || 'Valor inválido',
         max: v => (parseFloat(v || 0) * 100 <= this.subtotal) || 'Desconto maior que subtotal'
      }
    };
  },
  computed: {
     isValid() {
         const val = parseFloat(this.discountValue || 0) * 100;
         return val >= 0 && val <= this.subtotal;
     }
  },
  methods: {
    open(currentDiscount, subtotal) {
      this.subtotal = subtotal;
      this.discountValue = (currentDiscount / 100).toFixed(2);
      this.dialog = true;
    },
    close() {
      this.dialog = false;
    },
    confirm() {
      if(!this.isValid) return;
      
      this.$emit('apply', parseFloat(this.discountValue || 0) * 100);
      this.close();
    }
  }
};
</script>

<style scoped>
.border-bottom { border-bottom: 1px solid #eee; }
</style>
